function Error() {
    return (
        <div className="text-red-error text-xl text-center h-full w-full flex flex-col gap-4 items-center justify-center">
            An Error Has Occured
            <button
                className="btn-primary w-40"
                onClick={() => window.location.reload()}
            >
                Refresh
            </button>
        </div>
    );
}

export default Error;
